import { submitFormData } from '@scripts/modules/sendFormData.js';
import initValidation from '@scripts/utils/initValidation.js';

const formSelector = document.querySelector('.js-contact-form');
const actionUrlForm = formSelector.getAttribute('action') || window.wp_data.ajax;

const titleEl = formSelector.closest('.l-contact-form')?.querySelectorAll('.c-title');
// const originalTitle = titleEl?.textContent || '';
const successMsg = formSelector.getAttribute('data-success-message') || '';
const errorMsg = formSelector.getAttribute('data-error-message') || '';

const setTitle = (text, cssState, compact = false) => {
  if (!titleEl.length) return;
  titleEl.forEach((title) => {
    title.textContent = text;
    title.classList.remove('is-success', 'is-error', 'is-compact');
    if (cssState) title.classList.add(cssState);
    if (compact) title.classList.add('is-compact');
  });
};

const formValidator = await initValidation({
  formSelector,
  validateFields: {
    name: '.js-contact-form [name="name"]',
    email: '.js-contact-form [name="email"]',
    date: '.js-contact-form [name="date"]',
    number: '.js-contact-form [name="travelers"]',
    select: '.js-contact-form [name="destination"]',
    // eslint-disable-next-line no-dupe-keys
    select: '.js-contact-form [name="inquiry"]',
    text: '.js-contact-form [name="message"]',
    submit: '.js-contact-form button[type="submit"]',
  },
});

submitFormData({
  fetchUrl: actionUrlForm,
  formElement: formSelector,
  formValidation: formValidator,
  onSuccess: () => {
    const needCompact = successMsg.length > 20;
    setTitle(successMsg, 'is-success', needCompact);
    formSelector.reset();
  },
  onError: () => {
    const needCompact = errorMsg.length > 20;
    setTitle(errorMsg, 'is-error', needCompact);
  },
});
